<bit-side-nav [variant]="variant">
  <ng-content></ng-content>

  <ng-container slot="footer">
    <navigation-product-switcher></navigation-product-switcher>
    <app-toggle-width></app-toggle-width>
  </ng-container>
</bit-side-nav>
